import {
  RouteTargetRoutePairDescriptionQuery,
  RouteTargetRoutePairDescriptionQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

const query = gql`
  query RouteTargetRoutePairDescription($id: ID!) {
    productPrice {
      routePair {
        byId(id: $id) {
          id
          description
        }
      }
    }
  }
`;

export const useRouteTargetPageRoutePairDescription = (
  routePairCode: string
) => {
  const { data, loading } = useQuery<
    RouteTargetRoutePairDescriptionQuery,
    RouteTargetRoutePairDescriptionQueryVariables
  >(query, {
    variables: { id: routePairCode },
  });

  const routePairDescription = data?.productPrice.routePair.byId?.description;

  return {
    routePairDescription,
    loading,
  };
};
